import iso6391 from "iso-639-1";

export default class Language {

    static compare(a: Language | string, b: Language | string) {
        const aLanguage = a instanceof Language ? a : Language.fromCode(a);
        const bLanguage = b instanceof Language ? b : Language.fromCode(b);
        return aLanguage.compareTo(bLanguage);
    }

    static fromCode(code: string) {
        return new this(code);
    }

    get countryCode() {
        return {
            cs: "CZ",
            da: "DK",
            de: "DE",
            et: "EE",
            en: "GB",
            es: "ES",
            fr: "FR",
            hr: "HR",
            it: "IT",
            hu: "HU",
            nl: "NL",
            nb: "NO",
            // Taxonomy data stores Norwegian as "no", not "nb" — without this
            // entry every Norwegian row renders without a flag.
            no: "NO",
            pl: "PL",
            pt: "PT",
            ro: "RO",
            sk: "SK",
            fi: "FI",
            // "SV" is El Salvador; Sweden is "SE".
            sv: "SE",
            tr: "TR",
            bg: "BG",
            ru: "RU",
            sr: "RS",
            uk: "UA",
            ja: "JP",
            sl: "SI",
        }[this.code];
    }

    get name() {
        return iso6391.getName(this.code);
    }

    get nativeName() {
        return iso6391.getNativeName(this.code);
    }

    constructor(
        readonly code: string,
    ) {}

    compareTo(language: Language) {
        return this.nativeName.localeCompare(language.nativeName);
    }

}

export const SUPPORTED_LANGUAGES = [
    "cs",
    "da",
    "de",
    "et",
    "en",
    "es",
    "fr",
    "hr",
    "it",
    "hu",
    "nl",
    "nb",
    "pl",
    "pt",
    "ro",
    "sk",
    "fi",
    "sv",
    "tr",
    "bg",
    "ru",
    "sr",
    "uk",
    "ja",
    "sl",
];
